export var commonSelectedStyles = 'emoji-common-selected';
export var selectOnHoverStyles = 'emoji-common-select-on-hover';
export var emojiSprite = 'emoji-common-emoji-sprite';
export var emojiNodeStyles = 'emoji-common-node';
export var emojiImage = 'emoji-common-emoji-image';
export var emojiDeleteButton = 'emoji-common-deleteButton';
export var emojiMainStyle = 'emoji-common-main-styles';
export var deletableEmoji = 'emoji-common-deletable';
export var placeholder = 'emoji-common-placeholder';
export var emojiPickerAddEmoji = 'emoji-picker-add-emoji';